import type { SVGProps } from 'react';
const SvgArrowRightGoals = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.793 3.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L9.086 8 5.793 4.707a1 1 0 0 1 0-1.414Z"
    />
  </svg>
);
export default SvgArrowRightGoals;
